<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="220"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_twentyThreeData'"
    :sqOptions="[ 9, 8]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesTwentyThree',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 64)
      } else if (value === 2) {
        this.$emit('handleProgress', 64)
      } else if (value === 3) {
        this.$emit('handleProgress', 55)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
